import React from "react";
import "./PageDesign/Styles/Footer.css";
import { useNavigate } from 'react-router-dom';

function Footer() {
  const Navigate = useNavigate();

  return (
    <div className="PageFooter">
      <div className="PageFooterContent">
        <div className="PageFooterUpperFlex">
          <div className="PageFooterUpperText">¡Poseemos los máximos estándares de seguridad! Tu información de salud, siempre estará segura, protegida y completamente PRIVADA.</div>
          <img alt="" className="PageFooterUpperImage" src="https://static.yomecontrolo.cl/public/icons/PurpleSecurityIcon.png" />
        </div>
        <div className="PageFooterUpperLogoDiv">
          <img alt="YoMeControlo Logo" className="PageFooterUpperLogo" src="https://static.yomecontrolo.cl/public/icons/YMC_WLogo_Text.png"/>
        </div>
      </div>
    </div >
  );
}
export default Footer;
